import { TDateISO } from "api/common/types/datetime.types";
import { valueof } from "api/common/utils/type.utils";

import { ProtectionProfileStub } from "../project/protectionProfiles/protectionProfiles.types";

export const TD_STATUS = {
  PENDING: "Pending",
  ARCHIVED: "Archived",
  INTEGRATED: "Integrated",
  WITHDRAWN: "Withdrawn",
  PROPOSED: "TD Proposed",
  RESOLVED: "Resolved",
  PUBLISHED: "Published",
  NEW: "New",
  VALID: "Valid",
} as const;
export type TdStatus = valueof<typeof TD_STATUS>;

interface BasePublicTechnicalDecision {
  td_id: number;
  identifier: string;
  title: string;
  publication_date: TDateISO;
  protection_profile: ProtectionProfileStub[];
  sunset_protection_profile: ProtectionProfileStub[];
  related_to: string;
}
export interface PublicTechnicalDecision extends BasePublicTechnicalDecision {
  description: string;
  resolution: string;
  justification: string;
}

export interface PublicTechnicalDecisionTableItem extends BasePublicTechnicalDecision {
  removed_on: TDateISO;
  status: TdStatus;
}
